import { useMemo, useRef } from 'react'

export function useStableRef<T>(value: T) {
  const stable = useRef(value)
  stable.current = useMemo(() => value, [value])
  return stable
}
